import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import BANNER_IMG from "../../assets/GirlWithLaptop.png";
import BACKGROUND_IMAGE from "../../assets/BgOverlayImage.jpeg";
import PageBanner from "../PageBanner/PageBanner";
import CartItem from "./CartItem";
import SuggestedBooks from "./SuggestedBooks";
import PricingSection from "./PricingSection";
import { ShoppingCart } from "lucide-react";
import EmptyCartLottie from "../Lottie-Components/EmptyCartLottie";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import useAutoLogout from "../../utils/useAutoLogout";
import userLogout from "../../utils/userLogout";

const BuyPage = () => {
  const cart = useSelector((store) => store.cart.cart);
  const [apiResponse, setApiResponse] = useState(null);
  const [planId, setPlanId] = useState("");
  const [cartItems, setCartItems] = useState([]);
  const [suggestedBooks, setSuggestedBooks] = useState(null);
  const [gst, setGst] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchDetails = async (retries = 6) => {
    try {
      const authToken = sessionStorage.getItem("token");

      if (!cart?.item || !cart?.id) {
        console.error("Cart data missing:", cart);
        navigate("/");
        return;
      }

      setPlanId(cart.plan_id)
      const requestOptions = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };

      const response = await fetch(
        process.env.REACT_APP_RANK_PLUS_CART +
        `${cart.item}/${cart.id}`,
        requestOptions
      );

      if (!response.ok) {

        // // Authentication / client error
        if (response.status >= 400 && response.status < 500) {
          console.error(
            "Cart API client/auth error:",
            response.status
          );

          userLogout(navigate, dispatch, true);
          return;
        }

        // Server error - retry
        if (response.status >= 500 && response.status < 600) {

          if (retries > 0) {
            console.warn(
              `Cart API ${response.status}. Retrying... attempts left: ${retries}`
            );

            setTimeout(() => {
              fetchDetails(retries - 1);
            }, 10000);

            return;
          }

          console.error(
            "Cart API failed after all retries:",
            response.status
          );

          throw new Error(
            `HTTP error: ${response.status}`
          );
        }

        throw new Error(
          `HTTP error: ${response.status}`
        );
      }

      const json = await response.json();
      console.log("Cart API response:", json);

      // if (!json?.status || !json?.data) {
      //   // throw new Error("Invalid cart API response");
      // }

      const gstPercentage = Number(json?.data?.gst || 0);

      setSuggestedBooks(
        Array.isArray(json?.data?.suggested_books)
          ? json.data.suggested_books
          : []
      );

      setGst(gstPercentage / 100);

      setApiResponse(json.data);

      setCartItems([
        {
          id: cart.id,
          name: cart.name,
          price: cart.price,
          thumbnail: cart.course_banner,
          sellingPrice: Math.ceil(
            Number(cart.price || 0) /
            (1 + gstPercentage / 100)
          ),
          show: false,
        },
      ]);
    } catch (err) {
      console.error("Error fetchDetails", err);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  function removeFromCart(id) {
    const excludedItem = cartItems.filter((ele) => ele?.id === id);
    if (cart?.id !== excludedItem[0]?.id) {
      setSuggestedBooks((prevState) => [...prevState, ...excludedItem]);
    }
    const remainingItems = cartItems.filter((ele) => ele?.id !== id);
    setCartItems(remainingItems);
  }

  return (
    <div className="overflow-hidden">
      <div>
        <PageBanner
          title={"Cart Checkout"}
          subtitle={""}
          rightImgSrc={BANNER_IMG}
          backgroundGradient={
            "linear-gradient(to right, rgba(254, 246, 250, 0.9) 45%, rgba(102, 269, 244, 0.8))"
          }
          backgroundImage={BACKGROUND_IMAGE}
          fontColor={"#130C40"}
        />
        {cartItems?.length === 0 ? (
          <div className="lg:mx-[15rem] mx-[1rem] mt-6">
            <EmptyCartLottie />
          </div>
        ) : (
          <div
            className={
              "lg:mx-[15rem] mx-[1rem] mt-6 flex md:flex-row flex-col-reverse justify-center " +
              (suggestedBooks?.length > 0
                ? "justify-between md:gap-[5rem] gap-[1rem]"
                : "justify-center")
            }
          >
            {/* left Section */}
            <div className="md:w-3/4 w-full">
              <div className="text-2xl font-semibold flex items-center gap-3 mb-[2rem]">
                <div>
                  <ShoppingCart />
                </div>
                <div>My Cart</div>
              </div>
              <div>
                {cartItems?.map((ele, i) => (
                  <CartItem
                    {...ele}
                    key={i}
                    removeFromCart={removeFromCart}
                    showTrash={ele?.show}
                  />
                ))}
              </div>
              <div>
                <PricingSection
                  cartData={apiResponse}
                  cartItems={cartItems}
                  planId={planId}
                  gst={gst}
                  suggestedBooks={suggestedBooks}
                />
              </div>
            </div>
            {/* Right Section */}

            {suggestedBooks?.length > 0 && (
              <div className="w-1/4">
                <SuggestedBooks
                  suggestedBooks={suggestedBooks}
                  setCartItems={setCartItems}
                  setSuggestedBooks={setSuggestedBooks}
                  gst={gst}
                  cart={cartItems}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BuyPage;
